// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"83c381fa","787":"cd3e9ff8"}[chunkId] + ".chunk.js";
};